<div class="font-serif">

  <!-- ═══ CONTROL BAR (Sort + Filter + Count) ═══ -->
  <div class="border-b border-gray-200 bg-white sticky top-0 z-30">
    <div class="max-w-[1440px] mx-auto px-3 md:px-6 flex items-center h-11 md:h-12 gap-2 md:gap-4">


      <!-- Filter button -->
      <button (click)="showFilterDrawer = true"
        class="flex items-center gap-1.5 border border-gray-200 rounded-lg px-2 md:px-3 py-1.5 text-[10px] md:text-xs font-bold uppercase tracking-wider text-gray-700 hover:border-gray-400 transition-all bg-white shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2">
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="8" y1="12" x2="16" y2="12" />
          <line x1="11" y1="18" x2="13" y2="18" />
        </svg>
        Filter
      </button>

      <!-- Spacer -->
      <div class="flex-1"></div>

      <!-- Product count -->
      <span class="text-xs md:text-sm text-[#600b0b] font-bold shrink-0">{{ totalRecords }} Products</span>
    </div>
  </div>

  <!-- Divider line -->
  <div class="border-b-2 border-[#600b0b]"></div>

  <!-- ═══ ACTIVE FILTERS ═══ -->
  <div *ngIf="activeThemeName || selectedSubCategories.length || selectedArtTypes.length || selectedOrientations.length"
    class="max-w-[1440px] mx-auto px-3 md:px-6 pt-3 pb-1">
    <div class="flex flex-wrap items-center gap-2">
      <span class="text-[10px] md:text-xs text-gray-500 font-semibold uppercase tracking-wider">Filters:</span>

      <!-- Theme from route -->
      <span *ngIf="activeThemeName"
        class="inline-flex items-center gap-1.5 bg-[#600b0b] text-white text-[10px] md:text-xs font-semibold px-3 py-1 rounded-full">
        {{ activeThemeName }}
        <button (click)="removeThemeFilter()" class="hover:text-gray-200 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </span>

      <!-- Sub-category chips -->
      <ng-container *ngFor="let slug of selectedSubCategories">
        <span
          class="inline-flex items-center gap-1.5 bg-[#600b0b] text-white text-[10px] md:text-xs font-semibold px-3 py-1 rounded-full">
          {{ slug | titlecase }}
          <button (click)="toggleFilter('image_subcategory_id', slug, false); loadProducts()"
            class="hover:text-gray-200 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </span>
      </ng-container>

      <!-- Clear all -->
      <button (click)="clearAll()"
        class="text-[10px] md:text-xs text-[#600b0b] font-bold underline hover:text-[#8c1c1c] transition-colors ml-1">
        Clear All
      </button>
    </div>
  </div>

  <!-- ═══ PRODUCT GRID ═══ -->
  <div class="max-w-[1440px] mx-auto px-3 md:px-6 py-4 md:py-6">

    <!-- Loading skeleton -->
    <div *ngIf="isLoading" class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
      <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]" class="animate-pulse">
        <div class="aspect-[4/3] rounded-lg md:rounded-xl bg-gray-200"></div>
        <div class="mt-2 md:mt-3 space-y-2">
          <div class="h-3 bg-gray-200 rounded w-3/4"></div>
          <div class="h-2 bg-gray-200 rounded w-1/2"></div>
          <div class="h-3 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="loadError && !isLoading" class="text-center py-16 md:py-20">
      <div
        class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4 md:mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" class="text-red-300">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h3 class="text-lg md:text-xl font-serif text-gray-600 mb-2">Failed to load products</h3>
      <button (click)="loadProducts()" class="text-[#600b0b] text-sm font-bold underline">Try again</button>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && !loadError && products.length === 0" class="text-center py-16 md:py-20">
      <div
        class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4 md:mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" class="text-gray-300">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <h3 class="text-lg md:text-xl font-serif text-gray-600 mb-2">No products found</h3>
    </div>

    <!-- Grid -->
    <div *ngIf="!isLoading && products.length > 0" class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
      <div *ngFor="let item of products" (click)="navigateToPDP(item)" class="group cursor-pointer">
        <!-- Image container -->

        <div class="relative aspect-[4/3] overflow-hidden shadow-sm group-hover:shadow-xl transition-all duration-500 bg-gray-100">
          <img [src]="getItemImage(item)" [alt]="getItemName(item)" class="w-full h-full object-cover"
            loading="lazy" />

          <!-- POPULAR badge (top-left) -->
          <div *ngIf="isPopular(item)" class="absolute top-0 left-0">
            <span
              class="bg-[#600b0b] text-white text-[8px] md:text-[9px] font-bold uppercase tracking-wider px-2 md:px-3 py-1 inline-block">
              POPULAR
            </span>
          </div>

          <!-- Discount badge (top-right) -->
          <div *ngIf="getDiscountPercent(item) > 0" class="absolute top-0 right-0">
            <div class="relative">
              <div class="bg-[#d4a828] text-white text-[9px] md:text-[11px] font-bold px-2 md:px-3 py-1 clip-discount">
                -{{ getDiscountPercent(item) }} %
              </div>
            </div>
          </div>
        </div>

        <!-- Product info -->
        <div class="mt-2 md:mt-3 px-0.5 md:px-1">
          <!-- Product name -->
          <h3 class="font-bold text-xs md:text-sm text-gray-900 truncate group-hover:text-[#600b0b] transition-colors">
            {{ getItemName(item) }}
          </h3>

          <!-- Size -->
          <p *ngIf="getItemSize(item)" class="text-[10px] md:text-xs text-gray-500 mt-0.5">
            Size- {{ getItemSize(item) }}
          </p>

          <!-- Price row -->
          <div class="flex items-center justify-between mt-1 md:mt-1.5">
            <div class="flex items-baseline gap-1.5">
              <span *ngIf="getItemMrp(item) > 0 && getItemMrp(item) !== getItemPrice(item)"
                class="text-[10px] md:text-xs text-gray-400 line-through">
                ₹{{ getItemMrp(item) | number:'1.2-2' }}
              </span>
              <span *ngIf="getItemPrice(item) > 0" class="text-xs md:text-sm font-bold text-[#600b0b]">
                ₹{{ getItemPrice(item) | number:'1.2-2' }}
              </span>
            </div>


          </div>
        </div>
      </div>
    </div>


    <!-- FILTER SIDENAV -->
    <div *ngIf="showFilterDrawer" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-black/40" (click)="showFilterDrawer = false"></div>
      <div class="fixed left-0 top-0 bottom-0 w-full max-w-[420px] bg-white flex flex-col shadow-2xl z-50">
        <!-- Header -->
        <div class="px-6 py-5 shrink-0">
          <h2 class="text-lg font-medium text-gray-900" style="font-family: 'Roboto', sans-serif;">Apply Filters</h2>
        </div>
        <!-- Panels -->
        <div class="flex-1 overflow-y-auto divide-y divide-gray-200">

          <!-- THEMES -->
          <div class="bg-white">
            <button (click)="toggleSection('image_subcategory_id')"
              class="w-full flex items-center justify-between px-6 py-5">
              <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Themes</h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                [class]="'transition-transform text-gray-300 ' + (openSections.image_subcategory_id ? 'rotate-180' : '')">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div *ngIf="openSections.image_subcategory_id" class="px-6 pb-4 space-y-3">
              <div *ngFor="let item of topCategories"
                class="flex items-center gap-3 py-1 cursor-pointer"
                (click)="toggleTheme(item)">
                <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (isThemeSelected(item) ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
                  <svg *ngIf="isThemeSelected(item)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span class="text-[15px] text-gray-700 flex-1">{{ item.title }}</span>
                <span class="text-sm text-gray-400">( {{ getFacetCount('image_subcategory_id', item.id) }} )</span>
              </div>
            </div>
          </div>

          <!-- ORIENTATION -->
          <div class="bg-white">
            <button (click)="toggleSection('orientation')"
              class="w-full flex items-center justify-between px-6 py-5">
              <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Orientation</h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                [class]="'transition-transform text-gray-300 ' + (openSections.orientation ? 'rotate-180' : '')">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div *ngIf="openSections.orientation" class="px-6 pb-4 space-y-3">
              <div *ngFor="let item of shapes"
                class="flex items-center gap-3 py-1 cursor-pointer"
                (click)="item.activated = !item.activated; toggleFilter('orientation', item.code, item.activated)">
                <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
                  <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
                <span class="text-sm text-gray-400">( {{ getFacetCount('orientation', item.code) }} )</span>
              </div>
            </div>
          </div>

          <!-- TYPE OF ART -->
          <div class="bg-white">
            <button (click)="toggleSection('artType')"
              class="w-full flex items-center justify-between px-6 py-5">
              <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Type of Art</h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                [class]="'transition-transform text-gray-300 ' + (openSections.artType ? 'rotate-180' : '')">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div *ngIf="openSections.artType" class="px-6 pb-4 space-y-3">
              <div *ngFor="let item of artTypes"
                class="flex items-center gap-3 py-1 cursor-pointer"
                (click)="item.activated = !item.activated; toggleFilter('art_type', item.id, item.activated)">
                <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
                  <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
                <span class="text-sm text-gray-400">( {{ getFacetCount('art_type', item.id) }} )</span>
              </div>
            </div>
          </div>

        </div>

        <!-- APPLY / CLEAR ALL -->
        <div class="flex shrink-0">
          <button (click)="applyFilters()"
            class="flex-1 bg-[#600b0b] text-white text-xs font-bold uppercase tracking-[0.25em] py-4 hover:bg-[#8c1c1c] transition-all">
            APPLY
          </button>
          <button (click)="clearAll(); showFilterDrawer = false"
            class="flex-1 bg-white text-gray-600 text-xs font-bold uppercase tracking-[0.25em] py-4 border border-gray-200 hover:text-[#600b0b] transition-all">
            CLEAR ALL
          </button>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && totalPages > 1" class="flex items-center justify-center gap-1.5 md:gap-2 mt-8 md:mt-10">
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
        class="w-8 h-8 md:w-9 md:h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-30 disabled:cursor-not-allowed">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <ng-container *ngFor="let p of pageNumbers">
        <span *ngIf="p === -1" class="text-gray-400 text-xs md:text-sm px-0.5 md:px-1">…</span>
        <button *ngIf="p !== -1" (click)="goToPage(p)"
          [class]="'w-8 h-8 md:w-9 md:h-9 rounded-full border flex items-center justify-center text-[10px] md:text-xs font-bold transition-all ' + (p === currentPage ? 'bg-[#600b0b] text-white border-[#600b0b]' : 'border-gray-200 hover:border-[#600b0b] hover:text-[#600b0b]')">{{
          p }}</button>
      </ng-container>
      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
        class="w-8 h-8 md:w-9 md:h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-30 disabled:cursor-not-allowed">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <!-- Page info -->
    <p *ngIf="!isLoading && totalRecords > 0"
      class="text-center text-[10px] md:text-[11px] text-gray-400 mt-3 md:mt-4 font-serif">
      Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ currentPage * pageSize > totalRecords ? totalRecords :
      currentPage * pageSize }} of {{ totalRecords }} products
    </p>
  </div>

</div>